module.exports = __webpack_public_path__ + "img/nodataicon.0875d2e5.svg";